import { EnvironmentUrls } from 'Roblox';

export const urlConfigs = {
  assetRootUrlTemplate: 'catalog',
  bundleRootUrlTemplate: 'bundles',
  avatarShopRecommendationUrl: `${EnvironmentUrls.websiteUrl}/catalog?Category=15`,
  numberOfItemsToDisplay: 6
};

export default urlConfigs;
